export * from './People1PlusIcon';
export * from './People1PlusIcon16Light';
export * from './People1PlusIcon16Regular';
export * from './People1PlusIcon16Solid';
export * from './People1PlusIcon20Light';
export * from './People1PlusIcon20Regular';
export * from './People1PlusIcon20Solid';
export * from './People1PlusIcon24Regular';
export * from './People1PlusIcon24Solid';
export * from './People1PlusIcon32Regular';
export * from './People1PlusIcon64Regular';
